{
	"title": "Mijn account",
	"or": "of",
	"field": {
		"email": "E-mailadres",
		"password": "Wachtwoord",
		"newPassword": "Nieuw wachtwoord",
		"firstName": "Voornaam",
		"lastName": "Achternaam",
		"phone": "Telefoonnummer",
		"street": "Straat",
		"houseNumber": "Huisnummer",
		"houseNumberAddition": "Toevoeging",
		"postcode": "Postcode",
		"city": "Plaats",
		"country": "Land",
		"recipientName": "T.a.v.",
		"companyName": "Bedrijfsnaam",
		"kvkNumber": "KvK-nummer",
		"vatId": "Btw-nummer",
		"repeatPassword": "Herhaal het wachtwoord"
	},
	"country": {
		"NL": "Nederland",
		"BE": "België"
	},
	"hint": {
		"phone": "Voor de bezorger, als die je nodig heeft.",
		"houseNumberAddition": "Bijvoorbeeld A of bis. Mag leeg.",
		"recipientName": "Voor wie het pakket is. Leeg: voor jou.",
		"optional": "Mag leeg.",
		"kvkNumber": "8 cijfers. Belgisch bedrijf? Vul je KBO-nummer in (10 cijfers).",
		"vatId": "Bijvoorbeeld NL123456789B01 of BE0123456789. We controleren het in het Europese btw-register (VIES)."
	},
	"placeholder": {
		"email": "naam@voorbeeld.nl"
	},
	"problem": {
		"rateLimited": "Je hebt het te vaak geprobeerd. Wacht een paar minuten en probeer het dan opnieuw.",
		"botCheckFailed": "De controle of je een mens bent lukte niet. Doe de controle opnieuw en verstuur het nog eens.",
		"botCheckUnavailable": "De controle of je een mens bent werkt nu even niet. Probeer het over een paar minuten opnieuw.",
		"botCheckRequired": "Het e-mailadres of wachtwoord klopt niet. Doe eerst de controle hieronder en probeer het dan opnieuw.",
		"invalidCredentials": "Dit e-mailadres en wachtwoord horen niet bij elkaar. Kijk ze na, of kies een nieuw wachtwoord via \"Wachtwoord vergeten\".",
		"emailNotConfirmed": "Je hebt je e-mailadres nog niet bevestigd. Klik op de link in de mail die we je stuurden, of vraag hieronder een nieuwe link aan.",
		"linkInvalid": "Deze link werkt niet meer: hij is al gebruikt, verlopen of vervangen door een nieuwere.",
		"invalidInput": "Een van de gegevens klopt niet. Kijk het formulier na en probeer het opnieuw.",
		"unknown": "Er ging iets mis. Probeer het zo nog eens; blijft het misgaan, neem dan contact met ons op.",
		"signedOut": "Je bent niet meer ingelogd. Log opnieuw in; daarna kom je hier terug.",
		"signInAgain": "Opnieuw inloggen",
		"addressLimitReached": "Je adresboek is vol: je kunt {{max}} adressen bewaren. Verwijder eerst een adres dat je niet meer gebruikt.",
		"addressNotFound": "Dit adres bestaat niet meer. Misschien heb je het in een ander venster verwijderd. We hebben je adresboek opnieuw geladen.",
		"businessApplicationExists": "Je hebt al een zakelijke aanvraag lopen, of je account is al zakelijk. Hieronder zie je hoe het ervoor staat.",
		"orderNotFound": "Deze bestelling vinden we niet in je account. Kijk het ordernummer na in je bestellingen."
	},
	"turnstile": {
		"failed": "De controle kon niet laden. Ververs de pagina en probeer het opnieuw."
	},
	"passwordRule": {
		"length_one": "Minstens {{count}} teken",
		"length_other": "Minstens {{count}} tekens",
		"met": "in orde",
		"notMet": "nog niet"
	},
	"link": {
		"expiredTitle": "Deze link werkt niet meer",
		"incompleteTitle": "Deze link is niet compleet"
	},
	"register": {
		"title": "Account maken",
		"intro": "Dan bestel je opnieuw met één knop en vind je al je facturen terug.",
		"address": "Je adres",
		"addressHint": "Dit wordt je standaard factuur- en bezorgadres. Je kunt later meer adressen toevoegen.",
		"submit": "Account maken",
		"legal": "We sturen je een mail om je e-mailadres te bevestigen. De link in die mail werkt 24 uur.",
		"haveAccount": "Heb je al een account?",
		"signIn": "Inloggen",
		"doneTitle": "Kijk in je mail",
		"doneText": "We hebben een mail gestuurd naar {{email}}. Klik op de link in die mail om je e-mailadres te bevestigen; daarna kun je inloggen. De link werkt 24 uur.",
		"doneExisting": "Heb je al een account met dit adres? Dan krijg je een mail om in te loggen.",
		"doneNoMail": "Geen mail gekregen, of is de link verlopen? Kijk ook bij je ongewenste mail, of vraag hieronder een nieuwe link aan."
	},
	"confirm": {
		"busy": "We bevestigen je e-mailadres…",
		"doneTitle": "Je e-mailadres is bevestigd",
		"doneText": "Je account is klaar. Log in om verder te gaan.",
		"toSignIn": "Naar inloggen",
		"toShop": "Verder winkelen",
		"invalidText": "Hij is al gebruikt, verlopen (een link werkt 24 uur) of vervangen door een nieuwere. Heb je je e-mailadres al bevestigd? Dan kun je gewoon inloggen. Anders vraag je hieronder een nieuwe link aan.",
		"missingToken": "Open de link uit de mail nog eens, of vraag hieronder een nieuwe aan.",
		"resendTitle": "Nieuwe bevestigingslink",
		"resendSubmit": "Stuur een nieuwe link",
		"resendDone": "Wacht er een account met {{email}} op bevestiging? Dan staat er nu een nieuwe link in je mail. De link werkt 24 uur.",
		"retry": "Probeer opnieuw"
	},
	"signIn": {
		"intro": "Een account is niet verplicht. Je bestelt er wel sneller mee opnieuw.",
		"submit": "Inloggen",
		"botCheckTitle": "Drie keer niet gelukt",
		"botCheckWhy": "Omdat inloggen drie keer niet lukte, vragen we eerst of je een mens bent. Zo blijft je account van jou.",
		"forgot": "Wachtwoord vergeten?",
		"register": "Account maken",
		"guest": "Verder zonder account"
	},
	"forgot": {
		"intro": "Vul je e-mailadres in. We sturen je een link om een nieuw wachtwoord te kiezen.",
		"submit": "Stuur de link",
		"doneTitle": "Kijk in je mail",
		"doneText": "Als er een account is met {{email}}, staat er nu een link in je mail. De link werkt een uur.",
		"noMail": "Geen mail? Kijk in je ongewenste mail, of",
		"sendAgain": "stuur hem opnieuw",
		"backToSignIn": "Terug naar inloggen"
	},
	"newPassword": {
		"title": "Kies een nieuw wachtwoord",
		"intro": "Kies een nieuw wachtwoord voor je account. Daarna log je ermee in.",
		"submit": "Wachtwoord opslaan",
		"repeatMismatch": "De twee wachtwoorden zijn niet hetzelfde. Typ het nog eens.",
		"doneTitle": "Je wachtwoord is gewijzigd",
		"doneText": "Log in met je nieuwe wachtwoord. Op andere apparaten ben je uitgelogd.",
		"toSignIn": "Naar inloggen",
		"invalidText": "Hij is al gebruikt, verlopen (een link werkt een uur) of vervangen door een nieuwere. Vraag een nieuwe link aan om je wachtwoord te wijzigen.",
		"missingToken": "Open de link uit de mail nog eens, of vraag een nieuwe aan.",
		"requestNew": "Nieuwe link aanvragen"
	},
	"home": {
		"greeting": "Hallo {{name}}",
		"greetingNoName": "Je account",
		"lastOrder": "Je laatste bestelling · {{date}}",
		"lastOrderSummary": "{{orderNumber}} · {{lines}} · {{total}}",
		"reorderLines": "Wat je bestelde",
		"lineQuantity": "{{count}}×",
		"viewOrder": "Bekijk de bestelling",
		"noOrders": {
			"title": "Nog geen bestellingen",
			"text": "Je eerste bestelling staat hier daarna, met de factuur en een knop om hem opnieuw te bestellen.",
			"action": "Kies je wisser"
		},
		"tiles": {
			"label": "Naar je account",
			"orders": "Facturen, track en trace, opnieuw bestellen",
			"addresses_one": "{{count}} adres",
			"addresses_other": "{{count}} adressen",
			"addressesNone": "Nog geen adressen",
			"details": "Naam, e-mail, wachtwoord, nieuwsbrief",
			"businessNone": "Op rekening betalen en eigen prijzen"
		}
	},
	"nav": {
		"label": "Mijn account",
		"overview": "Overzicht",
		"orders": "Bestellingen",
		"addresses": "Adresboek",
		"details": "Gegevens",
		"business": "Zakelijk",
		"logout": "Uitloggen"
	},
	"details": {
		"title": "Gegevens",
		"nameTitle": "Naam en e-mail",
		"emailFixed": "Met dit adres log je in. Wijzigen kan nog niet; mail ons als het anders moet.",
		"submit": "Opslaan",
		"saved": "Je gegevens zijn opgeslagen.",
		"password": {
			"title": "Wachtwoord",
			"text": "We mailen je een link naar {{email}}. Daarmee kies je een nieuw wachtwoord; daarna log je overal opnieuw in.",
			"submit": "Wachtwoord wijzigen",
			"sentTitle": "Kijk in je mail",
			"sent": "De link staat in je mail. Hij werkt een uur."
		},
		"newsletter": {
			"title": "Nieuwsbrief",
			"on": "Je krijgt de nieuwsbrief.",
			"off": "Je krijgt de nieuwsbrief niet meer."
		},
		"vatDisplay": {
			"title": "Prijzen tonen",
			"text": "Alleen hoe je prijzen ziet. Wat je betaalt, verandert niet.",
			"consumer": "Je betaalt altijd incl. btw.",
			"incl": "Incl. btw",
			"excl": "Excl. btw",
			"savedIncl": "Je ziet prijzen nu incl. btw.",
			"savedExcl": "Je ziet prijzen nu excl. btw."
		},
		"delete": {
			"title": "Account verwijderen",
			"text": "Je gegevens en adressen worden gewist. Facturen bewaren we [NOG INVULLEN: bewaartermijn, 7 jaar], omdat dat moet voor de belasting.",
			"how": "Stuur ons een bericht met je e-mailadres, dan verwijderen we je account.",
			"action": "Account laten verwijderen"
		}
	},
	"addresses": {
		"title": "Adresboek",
		"intro": "Je bewaart hier tot {{max}} adressen. Bij het afrekenen staat je standaardadres al klaar.",
		"empty": "Je hebt nog geen adressen bewaard.",
		"add": "Adres toevoegen",
		"full": "Je hebt {{max}} adressen, het maximum. Verwijder er een om een nieuw adres toe te voegen.",
		"newTitle": "Nieuw adres",
		"editTitle": "Adres wijzigen",
		"save": "Opslaan",
		"cancel": "Annuleren",
		"edit": "Wijzigen",
		"remove": "Verwijderen",
		"removeYes": "Ja, verwijder",
		"confirmRemove": "Dit adres verwijderen? Bestellingen met dit adres houden hun eigen kopie.",
		"added": "Het adres is toegevoegd.",
		"saved": "Het adres is gewijzigd.",
		"removed": "Het adres is verwijderd.",
		"defaultBilling": "Standaard factuuradres",
		"defaultShipping": "Standaard bezorgadres",
		"makeDefault": "Als standaard",
		"default": "Standaard",
		"defaultSet": "Dit is nu je standaardadres."
	},
	"orders": {
		"title": "Bestellingen",
		"empty": {
			"title": "Nog geen bestellingen",
			"text": "Bestellingen die je met dit account doet, staan hier met hun factuur."
		},
		"emptyPage": "Op deze pagina staan geen bestellingen.",
		"firstPage": "Naar je nieuwste bestellingen",
		"lineCount_one": "{{count}} product",
		"lineCount_other": "{{count}} producten",
		"pagesLabel": "Pagina's",
		"previous": "Nieuwere",
		"next": "Oudere",
		"pageOf": "Pagina {{page}} van {{pages}}",
		"back": "Alle bestellingen",
		"placedOn": "Besteld op {{date}}",
		"stage": {
			"awaitingPayment": "Wacht op betaling",
			"expired": "Niet betaald",
			"refunded": "Terugbetaald",
			"cancelled": "Geannuleerd",
			"preparing": "Wordt klaargemaakt",
			"shipped": "Verstuurd",
			"underway": "Onderweg"
		},
		"status": {
			"awaitingPayment": "We hebben je betaling nog niet binnen.",
			"awaitingPaymentUntil": "We hebben je betaling nog niet binnen. We houden de producten voor je vast tot {{date}}.",
			"expired": "De betaling kwam niet op tijd binnen. De bestelling is vervallen; je hebt niets betaald.",
			"cancelled": "Deze bestelling is geannuleerd.",
			"refunded": "We hebben het hele bedrag teruggestort.",
			"partlyRefunded": "We hebben een deel van het bedrag teruggestort.",
			"preparing": "Zodra je pakket onderweg is, zie je hier de track & trace.",
			"dueOn": "Op rekening: betaal de factuur uiterlijk {{date}}."
		},
		"trackParcel": "Volg je pakket: {{code}}",
		"invoice": "Factuur",
		"noInvoice": "De factuur staat hier zodra je bestelling betaald is.",
		"reorder": "Bestel opnieuw",
		"reorderFor": "Bestel opnieuw · {{amount}}",
		"lines": "Wat je bestelde",
		"addresses": "Adressen en betaling",
		"shippingAddress": "Bezorgadres",
		"billingAddress": "Factuuradres",
		"payment": "Betaald met",
		"contact": "Contact",
		"paymentMethod": {
			"ideal": "iDEAL",
			"bancontact": "Bancontact",
			"card": "Creditcard",
			"paypal": "PayPal",
			"bankTransfer": "Overboeking",
			"onAccount": "Op rekening"
		},
		"invoicePending": "De factuur staat hier zodra hij klaar is.",
		"toShop": "Naar de winkel",
		"openOrder": "Bekijk bestelling {{orderNumber}}",
		"heading": "Bestelling {{orderNumber}}",
		"stepsLabel": "Waar je bestelling is",
		"steps": {
			"placed": "Besteld",
			"shipped": "Verstuurd",
			"underway": "Onderweg",
			"delivered": "Bezorgd"
		},
		"trackingText": "Track en trace bij {{carrier}}: {{code}}",
		"documents": "Factuur en creditfacturen",
		"creditInvoice": "Creditfactuur {{number}} · {{amount}}",
		"download": "Download",
		"perPiece": "{{price}} per {{noun}}",
		"quantity": "{{count}}×",
		"returns": "Retour aanmelden",
		"withdrawal": "Herroepen binnen 14 dagen kan ook met het herroepingsformulier.",
		"pdf": "PDF"
	},
	"business": {
		"status": {
			"pending": "We bekijken je aanvraag. Je krijgt bericht per mail zodra hij is beoordeeld.",
			"approved": "Je account is zakelijk. Je ziet prijzen exclusief btw in de hele shop en kunt op rekening bestellen.",
			"rejected": "We hebben je aanvraag afgewezen. Klopt er iets niet? Pas je gegevens aan en vraag opnieuw aan, of mail ons."
		},
		"title": "Zakelijk",
		"companyTitle": "Bedrijfsgegevens",
		"change": "Gegevens wijzigen? Laat het ons weten, dan beoordelen we je aanvraag opnieuw."
	}
}
